import React from 'react';
import { useDragLayer } from 'react-dnd';

const CustomDragPreview: React.FC = () => {
  const { item, currentOffset, isDragging } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || !currentOffset) {
    return null;
  }

  const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px)`;

  return (
    <div
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        minWidth: '200px',
        top: 0,
        left: 100,
        transform,
        WebkitTransform: transform,
        zIndex: 1000,
      }}
    >
      <div
        style={{
          padding: '8px',
          backgroundColor: '#F9EAEF',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        }}
      >
        {item?.title}
      </div>
    </div>
  );
};

export default CustomDragPreview;